import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select, { createFilter } from 'react-select';

import {
  fetchBrandAffinityBrandsReport,
  fetchBrandAffinityCategoriesReport,
  fetchBrandAffinityTopPoisReport,
  fetchCategoryAffinityTopPoisReport,
  fetchBrandAffinityOrganisationOptions,
  fetchBrandAffinitySummaryCard,
  fetchBrandAffinitySubcategoriesOptions,
  setBrandAffinityTopPoisOrganisationOption,
  setBrandAffinityTopPoisSubcategoriesOption,
  downloadBrandAffinity,
  selectBrandAffinityTimePeriod,
} from '../store/actions/brandAffinity-action';

import {
  validateReportCriteria,
  insertTitle,
  insertSubTile,
  insertDigitalSubTitle,
  chooseDownloadableBtn,
  brandAndCategoryNotification,
  checkDefaultTab,
} from '../utilities/report-helpers';

import {
  isEmptyObject,
  isDataAvailable,
  selectConfig
} from '../utilities/helpers';
import {
  clearInsightsCriteriaBoundaries,
  setInsightsCriteriaBoundaries,
  setInsightsCriteriaType,
  clearInsightsCriteriaPois,
} from '../store/actions/criteria-actions';
import { setLastInsightPage } from '../store/actions/route-actions';

import Header from './Header';
import SVGIcon from '../components/SVGIcon';
import HomeInsightSidebar from './HomeInsightSidebar';
import InsightsNavBar from './InsightsNavBar';
import SelectionNotAvailable from '../components/SelectionNotAvailable';
import CopyrightAndVersion from '../components/CopyrightAndVersion';
import LoadingContainer from '../components/LoadingContainer';
import BarGraph from '../components/BarGraph';
import HorizontalBarGraph from '../components/HorizontalBarGraph';
import DownloadPdf from '../components/DownloadPdf';
import DownloadButton from '../components/public/DownloadButton';
import DownloadCSVButton from '../components/DownloadCSVButton';

const mapStateToProps = (
  {
    home,
    client,
    reports,
    insightsCriteria,
    homeInsights,
    brandAffinity,
    locations,
    auth,
  },
  ownProps
) => ({
  ...home,
  client,
  ...homeInsights,
  ...insightsCriteria,
  ...brandAffinity,
  attribute: insightsCriteria.attribute,
  showDownloadButton: client.showHomePage,
  report: reports.reportDictionary[ownProps.reportId],
  insightType: insightsCriteria.insightType,
  organisation: insightsCriteria.organisation,
  ...locations,
  organisationsAvailable:
    reports.reportDictionary &&
    reports.reportDictionary[ownProps.reportId] &&
    reports.reportDictionary[ownProps.reportId].organisationsAvailable,
  geographyAvailable:
    reports.reportDictionary &&
    reports.reportDictionary[ownProps.reportId] &&
    reports.reportDictionary[ownProps.reportId].geographyAvailable,
  ableToDownloadCSV: chooseDownloadableBtn(
    'brandAffinity',
    auth.tokenPayload.scopes,
    insightsCriteria.insightType
  ),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchBrandAffinityBrandsReport,
      fetchBrandAffinityCategoriesReport,
      fetchBrandAffinityTopPoisReport,
      fetchCategoryAffinityTopPoisReport,
      fetchBrandAffinitySummaryCard,
      fetchBrandAffinityOrganisationOptions,
      fetchBrandAffinitySubcategoriesOptions,
      setBrandAffinityTopPoisOrganisationOption,
      setBrandAffinityTopPoisSubcategoriesOption,
      downloadBrandAffinity,
      selectBrandAffinityTimePeriod,
      clearInsightsCriteriaBoundaries,
      setInsightsCriteriaBoundaries,
      setInsightsCriteriaType,
      clearInsightsCriteriaPois,
      setLastInsightPage
    },
    dispatch
  );

class BrandAffinityInsights extends React.Component {
  state = {
    sideBarOpen: true,
    currentAffinityType: 'brand_affinity',
    timePeriodArray: [],
    currentTimePeriod: this.props.selectedPeriod,
    currentBrandSelection: null,
    currentCategorySelection: null,
    isLoadTopPoisReport: false,
    showCriteriaModal: false,
    showSelectionWarning: false,
    selectionWarningText: '',
  };

  componentDidMount() {
    this.props.setLastInsightPage('/brand-affinity-insights')
    this.props.lastPage !== '/' && this.props.clearInsightsCriteriaBoundaries();
    this.props.clearInsightsCriteriaPois();

    this.props.setInsightsCriteriaBoundaries({
      adm0: null,
      adm1: null,
      adm2: null,
      adm3: null,
      adm4: null,
      baseline: { label: `Country`, value: `country` },
    });

    const selectedTab = checkDefaultTab(
      this.props.reportsType,
      this.props.insightType,
      this.props.geographyAvailable,
      this.props.organisationsAvailable
    );
    this.props.setInsightsCriteriaType(selectedTab);
    this.populateDatePeriodDropDown();
    // validate before getdata
    const validateResult = this.handelValidateReportCriteria(selectedTab);

    if (validateResult.showSelectionWarning === false) {
      this.loadData('');
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.criteriaId !== this.props.criteriaId) {
      // validate before getdata
      const selectedTab = checkDefaultTab(
        this.props.reportsType,
        this.props.insightType,
        this.props.geographyAvailable,
        this.props.organisationsAvailable
      );
      const validateResult = this.handelValidateReportCriteria(selectedTab);

    }
  };

  loadData = selectTab => {
    this.props.fetchBrandAffinityOrganisationOptions();
    this.props.fetchBrandAffinitySubcategoriesOptions();
    this.props.fetchBrandAffinityBrandsReport();
    this.props.fetchBrandAffinityCategoriesReport();
    this.props.fetchBrandAffinitySummaryCard();

    this.props.brandAffinityTopPoiCategoryOption !== null &&
      this.props.fetchCategoryAffinityTopPoisReport();
    this.props.brandAffinityTopPoiBrandOption !== null &&
      this.props.fetchBrandAffinityTopPoisReport();
  };

  handelValidateReportCriteria = selectedTab => {
    const reportCriteriaValid = validateReportCriteria({
      insightType: selectedTab,
      report: this.props.report,
      subcategory: this.props.subcategory,
      organisation: this.props.organisation,
    });

    this.setState(() => ({
      ...reportCriteriaValid,
    }));
    return reportCriteriaValid;
  };

  toggleSideBar = () =>
    this.setState(prevState => ({ sideBarOpen: !prevState.sideBarOpen }));

  handleTimePeriod = e => {
    this.setState({ currentTimePeriod: e });
    this.props.selectBrandAffinityTimePeriod(e);
    this.loadData();
  };

  handleTabChange = clickedType => {
    if (clickedType !== this.state.currentAffinityType) {
      if (clickedType === 'brand_affinity') {
        this.props.setBrandAffinityTopPoisOrganisationOption(
          this.props.brandAffinityTopPoiBrandOption
            ? {
                id: this.props.brandAffinityTopPoiBrandOption.value,
                name: this.props.brandAffinityTopPoiBrandOption.label,
              }
            : null
        );

        this.setState({
          currentAffinityType: 'brand_affinity',
          currentSelection: this.props.brandAffinityTopPoiBrandOption,
        });
      } else {
        this.props.setBrandAffinityTopPoisSubcategoriesOption(
          this.props.brandAffinityTopPoiCategoryOption
            ? {
                id: this.props.brandAffinityTopPoiCategoryOption.value,
                name: this.props.brandAffinityTopPoiCategoryOption.label,
              }
            : null
        );
        this.setState({
          currentAffinityType: 'category_affinity',
          currentSelection: this.props.brandAffinityTopPoiCategoryOption,
        });
      }
    }
  };

  handleOptionSelect = e => {
    if (this.state.currentAffinityType === 'brand_affinity') {
      this.props.setBrandAffinityTopPoisOrganisationOption({
        id: e.value,
        name: e.label,
      });
      this.setState({ currentBrandSelection: e });
      this.props.fetchBrandAffinityTopPoisReport();
    } else {
      this.props.setBrandAffinityTopPoisSubcategoriesOption({
        id: e.value,
        name: e.label,
      });
      this.setState({ currentCategorySelection: e });
      this.props.fetchCategoryAffinityTopPoisReport();
    }
  };

  renderFirstSummaryCard = () => {
    const { adm0, adm2, adm3, adm4, poiId, boundariesDictionary } = this.props;
    const foundIndex = [adm0, adm2, adm3, adm4, poiId].findIndex(
      element => element !== null
    );

    const selectedBoundary = adm0 || adm2 || adm3 || adm4 || poiId;

    if (this.props.baseline.value === 'country') {
      return `${boundariesDictionary.country.areas[0].name} devices`;
    }

    if (selectedBoundary === null || selectedBoundary === undefined) {
      // none boundary be choosed
      return boundariesDictionary.country && boundariesDictionary.country.areas
        ? `${boundariesDictionary.country.areas[0].name} devices`
        : `Country devices ${<br />}`;
    } else if (Array.isArray(selectedBoundary) && selectedBoundary.length > 1) {
      // multiple boundary be choosed

      return foundIndex === 3 || foundIndex === 4
        ? `Devices from Mutilple Districts / Major Cities`
        : `New Zealand devices`;
    }
    // only one boundary be choosed

    if (selectedBoundary === poiId && selectedBoundary[0].place) {
      return `${selectedBoundary[0].place} devices`;
    }

    return foundIndex === 3 || foundIndex === 4
      ? `${selectedBoundary[0].label.substring(
          selectedBoundary[0].label.indexOf(',') + 1
        )} devices`
      : `${selectedBoundary[0].label.substring(
          0,
          selectedBoundary[0].label.indexOf(',')
        )} devices`;
  };

  renderThirdSummaryCard() {
    if (this.isDigitalOrganisation()) {
      return `${this.props.report.props.customMobileApplicationsName}`;
    }
    return this.props.brandAffinitySummaryData &&
      this.props.brandAffinitySummaryData.poisCount > 1
      ? `points of interest`
      : `point of interest`;
  }

  OrganizeTopPoiData(data) {
    if (Array.isArray(data) && data.length !== 0) {
      const BrandAffinityArray = [];
      const confidenceOverLimitArray = [];
      const penetrationLessThan1Array = [];
      const penetrationAs100Array = [];
      const nullDataArray = [];
      const confidenceIntervalLimit =
        this.props.report.props.confidenceInterval || 0.05;

      data.forEach(item => {
        if (
          item.confidence === 0 &&
          item.brandAffinity === 0 &&
          item.penetration === 0
        ) {
          // filter no data item
          nullDataArray.push(item);
          item.showingStatus = 'grey';
        } else if (item.penetration >= 1) {
          // filter penetration == 100%
          penetrationAs100Array.push(item);
          item.showingStatus = 'grey';
        } else if (item.penetration <= 0.01) {
          // filter penetration <= 1%
          penetrationLessThan1Array.push(item);
          item.showingStatus = 'grey';
        } else if (item.confidence > confidenceIntervalLimit) {
          // filter confidence > 5%
          confidenceOverLimitArray.push(item);
          item.showingStatus = 'grey';
        } else {
          BrandAffinityArray.push(item);
        }
      });

      BrandAffinityArray.sort((a, b) => b.brandAffinity - a.brandAffinity);
      confidenceOverLimitArray.sort((a, b) => a.confidence - b.confidence);
      penetrationLessThan1Array.sort((a, b) => b.penetration - a.penetration);

      return BrandAffinityArray.concat(
        confidenceOverLimitArray,
        penetrationLessThan1Array,
        penetrationAs100Array,
        nullDataArray
      );
    }
    return data;
  }

  isDigitalOrganisation = () =>
    this.props.organisation !== null &&
    this.props.organisation.organisationType === 'digital';

  populateDatePeriodDropDown = () => {
    // Ticket issue #392
    let datePeriod = this.props.report.props.datePeriod.concat();
    // filter enable === false
    datePeriod = datePeriod.filter(o => o.enable === true);

    const excuteDefaultSelection = targetObj => {
      this.setState(() => ({
        currentTimePeriod: targetObj,
      }));
      this.props.selectBrandAffinityTimePeriod(targetObj);
    };

    if (datePeriod !== undefined && datePeriod.length > 0) {
      this.setState(() => ({ timePeriodArray: datePeriod }));
      const has90DaysObj = datePeriod.find(o => o.value === 90);
      has90DaysObj === undefined
        ? excuteDefaultSelection(datePeriod[0])
        : excuteDefaultSelection(has90DaysObj);
    }
  };

  render() {
    const {
      insightType,
      adm2,
      adm3,
      adm4,
      poiId,
      baseline,
      brandAffinityData,
      brandAffinityDataLoaded,
      isStatisticDisplay,
      downloadingCSV,
      reportId,
      workLocationsData,
      workLocationsDataLoaded,
      brandReportData,
      brandReportDataLoaded,
      categoriesReportDataLoaded,
      categoriesReportData,
      topPoisBrandAffinityData,
      topPoisBrandAffinityDataLoaded,
      topPoisCategoryAffinityData,
      topPoisCategoryAffinityDataLoaded,
      organisationOptionsData,
      subcategoriesOptionsData,
      downloadBrandAffinity,
      brandAffinityTopPoiBrandOption,
      brandAffinityTopPoiCategoryOption,
      brandAffinitySummaryData,
      brandAffinitySummaryDataLoaded,
    } = this.props;

    const showBrandAndCategory = brandAndCategoryNotification(
      brandReportData,
      categoriesReportData,
      this.state.currentTimePeriod
    );

    const dropDownOptions =
      this.state.currentAffinityType === 'brand_affinity'
        ? organisationOptionsData.map(item => ({
            label: item.name,
            value: item.id,
          }))
        : subcategoriesOptionsData.map(item => ({
            label: item.name,
            value: item.id,
          }));

    return (
      <div className="FootfallInsights" data-html2canvas-ignore="true">
        <Header />
        {this.state.sideBarOpen && (
          <HomeInsightSidebar
            loadData={this.loadData}
            toggleSideBar={this.toggleSideBar}
            reportId={this.props.reportId}
            reportsType="brandAffinity"
          />
        )}
        <main
          className={`FootfallInsights_main${
            this.state.sideBarOpen ? '' : ' FootfallInsights_main_full-width'
          }`}
        >
          {!this.state.sideBarOpen && (
            <button
              className="FootfallInsights_main_open-side-bar-button"
              onClick={this.toggleSideBar}
            >
              <SVGIcon icon="back-arrow" />
            </button>
          )}
          <div className="FootfallInsights_main_top">
            <div className="container">
              <div className="FootfallInsights_title-bar">
                <div className="FootfallInsights_title-bar_left">
                  <h1>
                    {insertTitle(this.props, this.state.showSelectionWarning)}
                  </h1>
                  <h3>
                    {this.isDigitalOrganisation()
                      ? insertDigitalSubTitle(
                          this.props,
                          this.state.showSelectionWarning
                        )
                      : insertSubTile(
                          this.props,
                          this.state.showSelectionWarning
                        )}
                  </h3>
                </div>
                <div className="FootfallInsights_date-range-group">
                  {
                    this.isDigitalOrganisation()
                      ? (
                        <div></div>
                      )
                      : (<Select
                        inputId="category"
                        className="FootfallInsights_time-period-selection"
                        placeholder="Type to search"
                        isDisabled={false}
                        isLoading={false}
                        isRtl={false}
                        isSearchable
                        name="category"
                        options={this.state.timePeriodArray}
                        onChange={this.handleTimePeriod}
                        value={this.state.currentTimePeriod}
                      />)

                  }
                  {(Array.isArray(this.props.ableToDownloadCSV) &&
                    this.props.ableToDownloadCSV.length > 0 &&
                    this.props.client.props.enableAudienceBuilder !== true ) && (
                    <DownloadCSVButton
                      downloadAudience={downloadBrandAffinity}
                      downloadingCSV={downloadingCSV}
                      label="Download audience .csv"
                      reportType='brandAffinity'
                      insightType={insightType}
                      ableToDownloadCSV={this.props.ableToDownloadCSV}
                    />
                  )
                  }
                </div>
              </div>

              <div>
                {!this.state.showSelectionWarning && (
                  <LoadingContainer loading={!brandAffinitySummaryDataLoaded}>
                    <div className="FootfallInsights_main_top_cards">
                      <div className="content-card">
                        <span className="FootfallInsights_main_top_cards_info">
                          {this.renderFirstSummaryCard()}
                        </span>
                        are the baseline
                      </div>
                      <div className="content-card">
                        <span className="FootfallInsights_main_top_cards_info">
                          95%
                        </span>
                        confidence level
                      </div>
                      <div className="content-card">
                        <span className="FootfallInsights_main_top_cards_info">
                          {brandAffinitySummaryData &&
                            brandAffinitySummaryData.poisCount}
                        </span>
                        {this.renderThirdSummaryCard()}
                      </div>
                    </div>
                  </LoadingContainer>
                )}
              </div>

            </div>
          </div>


          <div className="FootfallInsights_reports container">
            <InsightsNavBar selectedReport={reportId} />

            {this.state.showSelectionWarning ? (
              <SelectionNotAvailable
                text={this.state.selectionWarningText}
                buttonText={this.state.selectionWarningButtonText}
                openCriteriaModal={this.openCriteriaModal}
                wholePage
              />
            ) : (
              <div className="FootfallInsights_reports_tab-panel">
                <div className="FootfallInsights_reports_grid">
                  <LoadingContainer
                    loading={!brandReportDataLoaded}
                    className="FootfallInsights_reports_grid_top content-card"
                  >
                    {showBrandAndCategory.isBrandHaveData ? (
                      <BarGraph
                        data={brandReportData || []}
                        title="Brand affinity"
                        barOnScreen={10}
                        buttonOpen
                        statisticOpen={isStatisticDisplay}
                        isDataAvailable={isDataAvailable(brandReportData)}
                      />
                    ) : (
                      <SelectionNotAvailable
                        text={`No Brand ${showBrandAndCategory.text}`}
                        buttonText={showBrandAndCategory.buttonText}
                      />
                    )}
                  </LoadingContainer>

                  <LoadingContainer
                    loading={!categoriesReportDataLoaded}
                    className="FootfallInsights_reports_grid_left content-card"
                  >
                    {showBrandAndCategory.isCategoryHaveData ? (
                      <HorizontalBarGraph
                        data={
                          categoriesReportData
                            ? this.OrganizeTopPoiData(categoriesReportData)
                            : []
                        }
                        title="Category affinity"
                        subtitle=""
                        barOnScreen={8}
                        buttonOpen
                        statisticOpen={isStatisticDisplay}
                        isDataAvailable={isDataAvailable(categoriesReportData)}
                      />
                    ) : (
                      <SelectionNotAvailable
                        text={`No Category ${showBrandAndCategory.text}`}
                        buttonText={showBrandAndCategory.buttonText}
                      />
                    )}
                  </LoadingContainer>

                  {insightType === 'geography' ? (
                    <React.Fragment>
                      {adm4 === null ? (
                        <LoadingContainer
                          loading={!brandAffinityDataLoaded}
                          className="FootfallInsights_reports_grid_right content-card"
                        >
                          <HorizontalBarGraph
                            data={brandAffinityData || []}
                            title="Top suburbs by brand affinity"
                            subtitle=""
                            barOnScreen={7}
                            buttonOpen
                            selectOpen
                            statisticOpen={isStatisticDisplay}
                            isDataAvailable={isDataAvailable(brandAffinityData)}
                          />
                        </LoadingContainer>
                      ) : (
                        <LoadingContainer
                          loading={!workLocationsDataLoaded}
                          className="FootfallInsights_reports_grid_right content-card"
                        >
                          <HorizontalBarGraph
                            data={workLocationsData || []}
                            title="Top work locations by suburb"
                            subtitle=""
                            barOnScreen={8}
                            statisticOpen={isStatisticDisplay}
                            isDataAvailable={isDataAvailable(workLocationsData)}
                          />
                        </LoadingContainer>
                      )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <LoadingContainer
                        loading={
                          !(
                            topPoisBrandAffinityDataLoaded === true &&
                            topPoisCategoryAffinityDataLoaded === true
                          )
                        }
                        className="FootfallInsights_reports_grid_right content-card"
                      >
                        <div
                          className="FootfallOverTimeGraph_top-row_button-group"
                          style={{ float: 'right', marginTop: -15 }}
                        >
                          <button
                            onClick={() =>
                              this.handleTabChange('brand_affinity')
                            }
                            className={
                              this.state.currentAffinityType ===
                              'brand_affinity'
                                ? `selected`
                                : ''
                            }
                          >
                            Brand Affinity
                          </button>
                          <button
                            onClick={() =>
                              this.handleTabChange('category_affinity')
                            }
                            className={
                              this.state.currentAffinityType ===
                              'category_affinity'
                                ? `selected`
                                : ''
                            }
                          >
                            Category Affinity
                          </button>
                          <div className="TopTenOrganisations_selection-area">
                            <Select
                              inputId="category"
                              className="TopTenOrganisations_BarChart_select"
                              classNamePrefix="TopTenOrganisations_BarChart_select_"
                              placeholder="Type to search"
                              isDisabled={false}
                              isLoading={false}
                              // isRtl={false}
                              isSearchable
                              filterOption={createFilter(selectConfig)}
                              name="top-pois"
                              options={dropDownOptions}
                              onChange={e => this.handleOptionSelect(e)}
                              value={
                                this.state.currentAffinityType ===
                                'brand_affinity'
                                  ? this.state.currentBrandSelection
                                  : this.state.currentCategorySelection
                              }
                            />
                          </div>
                        </div>

                        {this.state.currentAffinityType === 'brand_affinity' ? (
                          // brand affinity top poi view
                          <HorizontalBarGraph
                            data={
                              topPoisBrandAffinityData
                                ? this.OrganizeTopPoiData(
                                    topPoisBrandAffinityData
                                  )
                                : []
                            }
                            title={
                              this.isDigitalOrganisation()
                                ? `Top ${
                                    this.props.report.props
                                      .customMobileApplicationsName
                                  }`
                                : `Top POI`
                            }
                            barOnScreen={7}
                            buttonOpen
                            brandAffinityText="brand"
                            statisticOpen={isStatisticDisplay}
                            showSelectionNotAvailable={isEmptyObject(
                              brandAffinityTopPoiBrandOption || {}
                            )}
                            isDataAvailable={isDataAvailable(
                              topPoisBrandAffinityData
                            )}
                            enableFrequency={
                              this.props.report.props.enableFrequency
                            }
                          />
                        ) : (
                          // category affinity top poi view
                          <HorizontalBarGraph
                            data={
                              topPoisCategoryAffinityData
                                ? this.OrganizeTopPoiData(
                                    topPoisCategoryAffinityData
                                  )
                                : []
                            }
                            title={
                              this.isDigitalOrganisation()
                                ? `Top ${
                                    this.props.report.props
                                      .customMobileApplicationsName
                                  }`
                                : `Top POI`
                            }
                            barOnScreen={7}
                            buttonOpen
                            brandAffinityText="category"
                            statisticOpen={isStatisticDisplay}
                            showSelectionNotAvailable={isEmptyObject(
                              brandAffinityTopPoiCategoryOption || {}
                            )}
                            isDataAvailable={isDataAvailable(
                              topPoisCategoryAffinityData
                            )}
                            enableFrequency={
                              this.props.report.props.enableFrequency
                            }
                          />
                        )}
                      </LoadingContainer>
                    </React.Fragment>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="FootfallInsights_DownlaodPdf">
            <DownloadPdf
              reportType="BrandAffinity"
              isDisabled={
                !(
                  brandAffinitySummaryDataLoaded &&
                  brandReportDataLoaded &&
                  categoriesReportDataLoaded &&
                  topPoisCategoryAffinityDataLoaded &&
                  topPoisBrandAffinityDataLoaded &&
                  !this.state.showSelectionWarning
                )
              }
            />
            <CopyrightAndVersion />
          </div>
        </main>
      </div>
    );
  }
}

BrandAffinityInsights.propTypes = {
  client: PropTypes.object.isRequired, // eslint-disable-line
  report: PropTypes.object.isRequired, // eslint-disable-line
  reportId: PropTypes.string.isRequired,
};

BrandAffinityInsights.defaultProps = {
  organisation: null,
  subcategory: null,
  insightType: null,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BrandAffinityInsights);
